export const config = {
  title: "M.A. AGUIRRE CONSTRUCTION LLC | Quality Construction Services in Trenton, NJ",
  meta: {
    description:
      "M.A. AGUIRRE CONSTRUCTION LLC offers professional construction services in Trenton, NJ, specializing in roofing, siding, gutters, chimneys, painting, home remodeling, storm damage repair, concrete works, steps, decks, and masonry.",
    keywords: [
      'Construction Trenton',
      'Roofing Services',
      'Siding Installation',
      'Gutter Repair',
      'Chimney Services',
      'Home Remodeling',
      'Storm Damage Repair',
      'Concrete Works',
      'Deck Construction',
      'Masonry Services',
      'M.A. AGUIRRE CONSTRUCTION LLC',
      'New Jersey Construction',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "M.A. AGUIRRE CONSTRUCTION LLC",
    canonicalUrl: 'https://aguirreconstruction.com/',
  },
  sections: {
    header: {
      businessName: "M.A. AGUIRRE CONSTRUCTION LLC",
    },
    sectionB: {
      heroTitle: "M.A. AGUIRRE CONSTRUCTION LLC",
      heroSubtitle: 'Your Trusted Partner in Quality Construction Services',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '6097363118',
      phoneLabel: '(609) 736-3118',
      heroBackgroundImage:
      'https://media.istockphoto.com/id/2167986788/photo/construction-crew-putting-up-framing-of-new-home.jpg?s=612x612&w=0&k=20&c=PmoyuOSrfFNh7cCUUS8gkmcoQ24jhaOTSrShw_Buobc=',
      cardData: [
        {
          title: 'Mission',
          description:
            'At M.A. AGUIRRE CONSTRUCTION LLC, our mission is to provide professional, reliable, and accessible construction services, committed to meeting your expectations and improving your home.',
        },
        {
          title: 'Vision',
          description:
            'Our vision is to be the leading provider of quality construction solutions in Trenton, NJ, known for our dedication to excellence and customer satisfaction.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With over 15 years of experience, a team of experts, and a comprehensive range of services, we are your trusted partner for all your construction needs.',
        },
      ],
      description:
        "M.A. AGUIRRE CONSTRUCTION LLC offers a wide range of construction services, including roofing, siding, gutters, chimneys, painting, home remodeling, storm damage repair, concrete works, steps, decks, and masonry. Our experienced team is dedicated to delivering exceptional results and transforming your home.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the comprehensive construction services we offer to meet your home improvement needs.",
      cards: [
        {
          title: 'Roofing',
          description:
            "Expert roofing installation, repair, and maintenance services to protect your home for years to come.",
          imageSrc:
            'https://aguirreconstruction.com/wp-content/uploads/2025/02/tile-roofing-worker-2023-11-27-05-35-06-utc-1536x975.jpg',
          imageAlt: 'Roofing Service'
        },
        {
          title: 'Siding',
          description:
            "Enhance your home's curb appeal and energy efficiency with our professional siding services.",
          imageSrc:
            'https://aguirreconstruction.com/wp-content/uploads/2025/02/Captura-de-pantalla-2025-02-03-083651-1.png',
          imageAlt: 'Siding Service',
        },
        {
          title: 'Home Remodeling',
          description:
            'Transform your living spaces with our comprehensive home remodeling services.',
          imageSrc:
            'https://aguirreconstruction.com/wp-content/uploads/2025/02/assembling-fitting-a-roof-window-skylight-with-2024-11-29-05-46-34-utc-1536x1021.jpg',
          imageAlt: 'Home Remodeling Service',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Gutter Repair',
        'Chimney Services',
        'Painting',
        'Storm Damage Repair',
        'Concrete Works',
        'Steps Construction',
        'Deck Construction',
        'Masonry Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://aguirreconstruction.com/wp-content/uploads/2025/02/male-painter-using-paint-roller-doing-exterior-pa-2025-01-16-22-17-45-utc-672x1024.jpg',
        alt: "M.A. AGUIRRE CONSTRUCTION LLC Team",
      },
      aboutText: [
        "At M.A. AGUIRRE CONSTRUCTION LLC, we are a team of dedicated professionals committed to transforming your home with precision, care, and unparalleled craftsmanship.",
        "With over 15 years of experience, we have earned a reputation for providing top-tier construction services across a variety of specialties. Our team is passionate about making your vision come to life, whether that means restoring the integrity of your home after a storm, enhancing its curb appeal, or creating custom outdoor spaces.",
      ],
    },
    sectionE: {
      profileImage: 'https://aguirreconstruction.com/wp-content/uploads/2025/02/Captura-de-pantalla-2025-02-02-215613-768x545.png',
      profileAlt: "M.A. AGUIRRE CONSTRUCTION LLC",
      businessName: "M.A. AGUIRRE CONSTRUCTION LLC",
      contact: {
        phone: '6097363118',
        phoneLabel: '(609) 736-3118',
        email: 'marvinaguirre1989@gmail.com',
        website: 'https://aguirreconstruction.com/',
        address: '22 Pierce Ave, Trenton, NJ 08629',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '22 Pierce Ave, Trenton, NJ 08629',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3050.123456789012!2d-74.1234567!3d40.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c1234567890!2s22+Pierce+Ave,+Trenton,+NJ+08629!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
